import { inject } from '@angular/core';
import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from '@openng/ngx-toastr';

export type CHSErrorMessage = {
  correlationId: string;
  errorMessage: string;
  stackTrace: any;
};

export function generateErrorMessage(error: CHSErrorMessage): string {
  let errorMsg = `Error message: ${error.errorMessage} `;
  let correlationID = `Correlation ID: ${error.correlationId} `;

  return `${errorMsg}\n${correlationID}`;
}

export const httpErrorInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const toastr = inject(ToastrService);
  const exceptionUrls = ['/v2/onboarding/onboard'];

  const bypass = exceptionUrls.some((url) => req.url.includes(url));

  if (bypass) {
    return next(req);
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const errObject = error.error as CHSErrorMessage;
      const errorTitle = `Server Error Code: ${error.status}, Message: ${error.message}`;
      const errorMessage = generateErrorMessage(errObject);
      toastr.error(errorMessage, errorTitle);

      return throwError(() => errorMessage);
    }),
  );
};
